export default __webpack_public_path__ + "static/media/Transfer-Button.ff319efb.svg";